'use client';

import { hasBasePath } from './getLanguage';
import { datadogLogs } from '@datadog/browser-logs';
import { LanguageTypes } from '@components/LetzChat';
import { LANGUAGE_OPTIONS } from './Navigation.constants';

export const RTL_LANGUAGES = ['ar'];
export const LANG_CODE_KEY = 'lang';
export function languageChange(
  languageCode: LanguageTypes
): Record<'success', boolean> {
  datadogLogs.logger.info('lzSwitchLanguage:', {
    languageCode,
    typeOfLZSwitchLanguage: typeof window.lzSwitchLanguage,
  });
  if (!LANGUAGE_OPTIONS.map(({ value }) => value).includes(languageCode)) {
    return { success: false };
  }
  if (typeof window.lzSwitchLanguage === 'function') {
    window.lzSwitchLanguage(languageCode);
    return { success: true };
  } else if (typeof window.letzchatChange === 'function') {
    window.letzchatChange(languageCode);
    return { success: true };
  } else {
    datadogLogs.logger.info(
      'lzSwitchLanguage and letzchatChange function not found'
    );
    return { success: false };
  }
}

export function getCurrentLanguage() {
  if (typeof window === 'undefined') return 'en';
  const pathArray = window.location.pathname.split('/');
  const languageCode = hasBasePath()
    ? pathArray[2]
    : (pathArray[1] as LanguageTypes);
  return languageCode;
}

export const updateLanguage = (languageCode: LanguageTypes) => {
  if (typeof window === 'undefined') {
    return;
  }
  updateLocaleInDOM(languageCode);
  languageChange(languageCode);
  return languageCode;
};

export const updateLocaleInDOM = (languageCode: LanguageTypes) => {
  if (typeof window === 'undefined') return;
  window.document.documentElement.setAttribute('lang', languageCode);
  window.document.documentElement.setAttribute(
    'dir',
    RTL_LANGUAGES.includes(languageCode) ? 'rtl' : 'ltr'
  );
  const htmlTag = window.document.querySelector(
    'html'
  ) as unknown as HTMLElement;
  if (htmlTag) {
    htmlTag.setAttribute('lang', languageCode);
    htmlTag.setAttribute(
      'dir',
      RTL_LANGUAGES.includes(languageCode) ? 'rtl' : 'ltr'
    );
  }
  const bodyTag = window.document.querySelector(
    'body'
  ) as unknown as HTMLBodyElement;
  if (bodyTag) {
    bodyTag.setAttribute('lang', languageCode);
    bodyTag.setAttribute(
      'dir',
      RTL_LANGUAGES.includes(languageCode) ? 'rtl' : 'ltr'
    );
  }
};
